<template>
  <div>
    <v-autocomplete
      :items="items"
      :label="label"
      item-text="name"
      item-value="id"
      v-model="selectedBookedBy"
      @change="onChange"
      :outlined="outlinedInputs"
      prepend-inner-icon="mdi-account"
      :disabled="!staff || staff.length == 0"
    ></v-autocomplete>
    <div v-if="debug">debug: [{{ value }}]</div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import EventBus from "../../../store/event-bus";
import { removeGQLTypename } from "../../../helpers";
const BOOKED_BY_LIST = gql`
  query bookedByStaff($agentId: ID) {
    ownerStaff: users(
      filter: { is_owner_staff: true, not_in_use_eq: false } #http://tracker.globetrack.ie/issues/6231
      orderBy: { fieldName: "name", direction: ASC }
    ) {
      edges {
        node {
          id
          name
          department
        }
      }
    }
    agentStaff: users(
      filter: { agent_id: $agentId, not_in_use_eq: false } #http://tracker.globetrack.ie/issues/6231
      orderBy: { fieldName: "name", direction: ASC }
    ) {
      edges {
        node {
          id
          name
          department
        }
      }
    }
  }
`;
export default {
  name: "BookedByListSelect",
  props: {
    label: {
      type: String,
      default: () => "Booked by",
    },
    agentId: {
      type: String,
      default: () => "",
    },
    value: {
      type: String,
      default: () => "",
    },
    bookedByName: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      debug: false,
      selectedBookedBy: null,
      items: [],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    selectStaff() {
      if (this.value && this.value != "" && this.staff) {
        const bookedBy = this.items.find((i) => i.id == this.value);
        if (bookedBy) {
          this.selectedBookedBy = bookedBy;
        } else {
          if (this.bookedByName != "" && this.value != "") {
            const bb = { name: this.bookedByName, id: this.value };
            this.items.push(bb);
            this.selectedBookedBy = bb;
          } else {
            this.selectedBookedBy = null;
          }
        }
      } else {
        this.selectedBookedBy = null;
      }
    },
    onChange(event) {
      if (event) {
        this.$emit("input", event);
      }
      const bookedBy = this.items.find((i) => i.id == event);
      if (bookedBy) {
        this.$emit("change", bookedBy);
      }
    },
  },
  watch: {
    value(newVal) {
      this.selectStaff();
    },
  },
  apollo: {
    staff: {
      query: BOOKED_BY_LIST,
      variables() {
        return {
          agentId: this.agentId,
        };
      },
      update(data) {
        return [...data.ownerStaff.edges, ...data.agentStaff.edges];
      },
      skip() {
        return !this.agentId || this.agentId == "";
      },
      result({ data }) {
        this.items = [
          ...data.ownerStaff.edges.map(removeGQLTypename),
          ...data.agentStaff.edges.map(removeGQLTypename),
        ];
        this.selectStaff();
      },
      fetchPolicy: "network-only",
    },
  },
  created() {
    EventBus.$on("reloadStaffList", () => {
      if (this.$apollo.queries.staff != null) {
        this.$apollo.queries.staff.refetch();
      }
    });
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/BookedByListSelect.vue